import { createContext, } from 'react';
import { modifiers } from './constants';
export const defaultContext = {
    isLoading: undefined,
    modifier: modifiers.default,
    name: 'picker',
    onChange: () => { },
    optionType: 'radio',
    selectedOptions: '',
};
export const PickerContext = createContext(defaultContext);
